// components/HowItWorks.jsx
import React from "react";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import styles from "../Info.module.css";

const steps = [
  { icon: "fa-file-video", desc: "فیلم یا سریال رو باز کن" },
  { icon: "fa-closed-captioning", desc: "زیرنویس‌ها رو فعال کن" },
  { icon: "fa-bookmark", desc: "روی لغات کلیک کن و ذخیره کن" },
  { icon: "fa-layer-group", desc: "توی لایتنر مرور کن" },
];

const HowItWorks = () => {
  return (
    <section className={styles.section}>
      <div className={styles.sectionInner}>
        <Reveal>
          <SectionHeading
            badge="ساده و سریع"
            badgeColor="teal"
            title="چطور کار می‌کنه؟"
            subtitle="فقط ۴ قدم تا یادگیری واقعی زبان."
          />
        </Reveal>

        <Reveal delay={100}>
          <div className={styles.stepsGrid}>
            {steps.map((step, idx) => (
              <div key={idx} className={styles.stepCard}>
                <span className={styles.stepNum}>{idx + 1}</span>
                <span className={styles.stepIcon}>
                  <i className={`fas ${step.icon}`}></i>
                </span>
                <span className={styles.stepDesc}>{step.desc}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default HowItWorks;